import randomstring from "randomstring";
import sha256 from "crypto-js/sha256";
import sha512 from "crypto-js/sha512";
import md5 from "crypto-js/md5";
import sha1 from "crypto-js/sha1";
import sha224 from "crypto-js/sha224";
import sha384 from "crypto-js/sha384";
import sha3 from "crypto-js/sha3";
import ripemd160 from "crypto-js/ripemd160";

import GeneratorView from "../../components/GeneratorView";
import GeneratorOptions from "./GeneratorOptions";

const hashAlgos = {
  sha256,
  md5,
  sha512,
  sha1,
  sha224,
  sha384,
  sha3,
  ripemd160,
};

const regEx = new RegExp(
  `${Object.keys(hashAlgos).join("|") + "|hashes"}`,
  "gi"
);

const extractType = ({ location: { pathname } }) => {
  const type = pathname.match(regEx)[0];
  return type?.toLowerCase() === "hashes" ? "sha256" : type || "sha256";
};

const generate = ({ location: { pathname }, history }, { count, type }) => {
  const newPath = pathname.replace(regEx, type);
  newPath !== pathname && history.push(newPath);
  return [...new Array(count)].map(() =>
    hashAlgos[type](randomstring.generate())
  );
};

const RandomHashesGenerator = (props) => (
  <GeneratorView
    onGenerate={(args) => generate(props, args)}
    strings={props.strings}
    toolStrings={props.toolStrings}
    options={{ type: extractType(props), count: 20 }}
    optionsView={GeneratorOptions}
  />
);

export default RandomHashesGenerator;
